import DataTable from '../DataTable.vue'
import { keepDimensions, buildCropFunction, valueAsNumber, trans } from '../dataFilter'
import { toScale } from '../colors'
import DataTableConfig from '../config/DataTable.vue'
import api from '../api'

export default {
  id: 'data-table-simple',
  label: 'Tableau',
  component: DataTable,
  multipleMeasure: () => true,
  dimensions: 1,
  adaptater: (data, vue) => {
    const props = {
      measures: vue.measure,
      formatters: {},
    }
    vue.metadata.measures.forEach(m => {
      props.formatters[api.measure.uniqueName(m)] = vue.buildMeasureFormatter(
        api.measure.uniqueName(m)
      )
    })
    if (vue.colorScheme) {
      props.colorScale = toScale(vue.colorScheme)
    }
    try {
      const config = JSON.parse(vue.specialConfig)
      if (config.properties) {
        props.properties = config.properties
      }
    } catch (error) {}
    vue.buildProps(props)
    const dimension = vue.dimension.find(d => {
      return api.dimension.uniqueName(d.value) === vue.activeDimensions[0]
    })
    if (dimension) {
      props.dimensionColumnTitle = trans(api.dimension.name(dimension.value), props.trans)
    }
    vue.buildProps(props)
    return buildCropFunction(d => {
      return vue.measure.length ? d.data[api.measure.name(vue.measure[0])] : 0
    }, vue)(keepDimensions(1, data).map(d => {
      const r = {}
      Object.keys(d).forEach(k => {
        r[k] = d[k]
      })
      vue.measure.forEach(m => {
        r[api.measure.name(m)] = valueAsNumber(r[api.measure.name(m)])
      })
      return { data: r }
    }).filter(d => !vue.noEmpty || vue.measure.map(m => d.data[api.measure.name(m)]).some(v => v)))
  },
  config: () => api.version > 1 ? DataTableConfig : null,
  configProps: [
    'myDimension'
  ],
  queryHandler: (query, vue) => {
    try {
      const config = JSON.parse(vue.specialConfig)
      query.properties = (config.properties || []).map(property => {
        return property.uniqueName
      }).join(',')
    } catch (error) {}
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/DataTable.js